import { graphql } from "gatsby"
import React from "react"

import Table from "@knowit-alma/common/src/components/atoms/Table/Table"
import TableFeatures from "@knowit-alma/common/src/components/atoms/TableFeatures/TableFeatures"

const CoreTable = ({ thead, tbody, captionHTML, className }) => {
  const isFeatureTable = className?.includes("table-features")
  return !isFeatureTable ? (
    <Table caption={captionHTML} head={thead} body={tbody} />
  ) : (
    <TableFeatures caption={captionHTML} head={thead} body={tbody} />
  )
}

export const query = graphql`
  fragment CoreTable on WpBlockCoreTable {
    __typename
    thead
    tbody {
      row
    }
    captionHTML
    className
  }
`

export default CoreTable
